"use strict"

import React from "react"
import {FormattedMessage} from "react-intl"
import ReactTooltip from "react-tooltip"
import {observer} from "mobx-react"
import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
import XsTable from "../../../../../global/ui/xsTable/xsTable"
import Moment from "moment"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import moment from "moment"
import {defaultScheme, insertSchemeWithRels} from "./consentBindings"
import {
	loadDataToFormByScheme,
	saveFormDataByScheme,
	deleteDataByScheme,
	resetForm,
	insertFormDataByScheme
} from "../../../../../global/helpers/bindings"
import bindings from "../../../../../global/ui/globalUISchemeBindings"
import XsConfirmationDialog from "../../../../../global/ui/xsDialog/xsConfirmationDialog"
import XsDateTimePicker from "../../../../../global/ui/xsDateTimePicker/xsDateTimePicker"
import XsInput from "../../../../../global/ui/xsInput/xsInput"
import XsButton from "../../../../../global/ui/xsButton/xsButton"
import SearchSelect from "../../../../../global/ui/xsSearchSelect/xsSearchSelect"
import Grid from "@material-ui/core/Grid"
import SaveIcon from "@material-ui/icons/Done"
import CancelIcon from "@material-ui/icons/Clear"
import fields from "./consentFields"
import DataStore from "../../../stores/DataStore"
import ConsentFormStore from "../../../stores/ConsentFormStore"
import GlobalStore from "../../../../../global/store/GlobalStore"
import {getUserPersonnelID, getSelectedOrgUnitID} from "../../../../../global/helpers/actions"
import ConsentTemplateDialog from "./consentTemplateDialog"

@observer
export default class ConsentTableEx extends React.Component {
	constructor(props) {
		super(props)

		const hooks = {
			onSubmit(/*form*/) {
				// special validation here
			},
			onSuccess(form) {
				const from = form.$("from").value
				if (from instanceof moment) {
					form.$("from").value = form.$("from").value.format("YYYY-M-D")
				}
				const to = form.$("to").value
				if (to instanceof moment) {
					form.$("to").value = form.$("to").value.format("YYYY-M-D")
				}

				if (ConsentFormStore.editable) {
					saveFormDataByScheme(
						form,
						defaultScheme,
						null,
						() => DataStore.getPatientConsents(),
						false,
						"Patient.form.consentForm.editSuccess"
					)
					ConsentFormStore.editable = false
				} else {
					const ids = getSelectedOrgUnitID()
					insertFormDataByScheme(
						form,
						insertSchemeWithRels,
						{
							relships: [
								{
									relship: {_id: props.clientId, _type: "Entity.Data.Client"},
									role: {_id: "client", _type: "CRM.CL.ConsentRelshiRole"},
									signed: true,
									_ref: false,
									_type: "CRM.Data.RelshipInConsent"
								},
								{
									relship: {_id: ids, _type: "Entity.Data.OrgUnit"},
									role: {_id: "provider", _type: "CRM.CL.ConsentRelshiRole"},
									signed: false,
									_ref: false,
									_type: "CRM.Data.RelshipInConsent"
								},
								{
									relship: {_id: getUserPersonnelID(), _type: "EHR.Data.Entity.Personnel"},
									role: {_id: "personprovider", _type: "CRM.CL.ConsentRelshiRole"},
									signed: false,
									_ref: false,
									_type: "CRM.Data.RelshipInConsent"
								}
							]
						},
						() => DataStore.getPatientConsents(),
						false,
						"Patient.form.consentForm.savesuccess"
					)
				}

				form.reset()
				ConsentFormStore.isAdd = false
			},
			onError() {}
		}

		this.form = new MobxReactForm(fields.load(), {plugins: {dvr: validatorjs}, hooks, bindings})

		this.initForm()
	}

	form

	initForm() {
		resetForm(this.form, defaultScheme)
	}

	onHandleRowClick = (dataRow) => {
		loadDataToFormByScheme(this.form, defaultScheme, {consentId: dataRow.actions._id})

		ConsentFormStore.editable = true
		ConsentFormStore.isAdd = true
	}

	deleteConsent = () => {
		deleteDataByScheme(
			defaultScheme,
			GlobalStore.confirmationDialogParams.consentId,
			() => DataStore.getPatientConsents(),
			"Patient.form.consentForm.deleteMessage"
		)
		ConsentFormStore.editable = false
		this.initForm()
	}

	render() {
		return (
			<div className="xs-consent-table-ex">
				<div className="xs-table">
					<XsTable
						config={{
							columnDefs: {
								type: {
									title: <FormattedMessage id="Patient.form.patientrecord.diagnosistype" />,
									type: "string",
									design: {
										width: "500px"
									},
									sortable: true
								},
								name: {
									title: <FormattedMessage id="Common.label.name" />,
									type: "string",
									sortable: true
								},
								from: {
									title: <FormattedMessage id="Common.label.from" />,
									type: "datetime",
									design: {
										width: "120px",
										body: {
											formatter: (props) => {
												return isSafe(props) && isNotEmpty(props) ? Moment(props).format("DD.MM.YYYY") : ""
											}
										}
									},
									sortable: true
								},
								to: {
									title: <FormattedMessage id="Common.label.to" />,
									type: "datetime",
									design: {
										width: "120px",
										body: {
											formatter: (props) => {
												return isSafe(props) && isNotEmpty(props) ? Moment(props).format("DD.MM.YYYY") : ""
											}
										}
									},
									sortable: true
								},
								actions: {
									title: "",
									type: "action",
									design: {
										width: "85px",
										body: {
											renderer: (props) => {
												return (
													<div>
														<XsIconButton
															className="action-print"
															icon={
																<span>
																	<i className="fal fa-print fa-lg xs-greyDefault" data-tip data-for="printConsent"></i>
																	<ReactTooltip id="printConsent" effect="solid">
																		<FormattedMessage id="Common.label.printConsent" />
																	</ReactTooltip>
																</span>
															}
															onClick={() => {
																if (props.value.consentTypeId == "hcpagr") {
																	ConsentFormStore.openConsentTemplate(props.value._id)
																} else {
																	ConsentFormStore.printConsent(props.value._id)
																}
															}}
														/>
														<XsIconButton
															className="action-delete"
															icon={
																<span>
																	<i
																		className="fal fa-trash-alt fa-lg xs-greyDefault"
																		data-tip
																		data-for="removeConsent"
																	/>
																	<ReactTooltip id="removeConsent" effect="solid">
																		<FormattedMessage id="Common.label.removeConsent" />
																	</ReactTooltip>
																</span>
															}
															onClick={() =>
																GlobalStore.openConfirmationDialog("xsDeletePatientConsent", {
																	consentId: props.value._id
																})
															}
														/>
													</div>
												)
											}
										}
									}
								}
							},
							options: {
								hidePager: true,
								showCursor: true,
								onRowClick: (dataRow) => {
									this.onHandleRowClick(dataRow)
								},
								mapper: (dataRow) => {
									const consentValidity = isSafe(dataRow.consents) ? dataRow.consents.find((x) => x.active) : null
									return {
										type: isSafe(consentValidity) ? consentValidity.type.description : "",
										name: dataRow.name,
										from: isSafe(consentValidity) ? consentValidity.validity.from : "",
										to: isSafe(consentValidity) ? consentValidity.validity.to : "",
										actions: {_id: dataRow._id, consentTypeId: isSafe(consentValidity) ? consentValidity.type._id : ""}
										// "delete": dataRow._id
									}
								}
							},
							dataSource: DataStore.patientDTO.get("consents")
						}}
					/>
				</div>
				<div className="xs-form">
					{ConsentFormStore.isAdd ? (
						<form>
							<Grid container direction="row" spacing={8}>
								<Grid item xs={3}>
									<SearchSelect
										field={this.form.$("type")}
										items={GlobalStore.CL["consentTypes"]}
										required
										menuPlacement="top"
									/>
								</Grid>
								<Grid item xs={2}>
									<XsInput white={true} field={this.form.$("name")} />
								</Grid>
								<Grid item xs={2}>
									<XsDateTimePicker field={this.form.$("from")} showTimeSelect={false} />
								</Grid>
								<Grid item xs={2}>
									<XsDateTimePicker field={this.form.$("to")} showTimeSelect={false} />
								</Grid>
								<Grid item xs={3} className="xs-form-actions">
									{ConsentFormStore.editable ? (
										<XsButton
											className="xs-success mr-3"
											type="submit"
											onClick={this.form.onSubmit}
											text={<FormattedMessage id="Common.label.save" />}
											icon={<SaveIcon />}
										/>
									) : (
										<XsButton
											className="xs-success mr-3"
											type="submit"
											onClick={this.form.onSubmit}
											text={<FormattedMessage id="Common.label.add" />}
											icon={<SaveIcon />}
										/>
									)}
									<XsButton
										className="xs-default xs-outline"
										onClick={() => {
											this.initForm()
											ConsentFormStore.isAdd = false
											ConsentFormStore.editable = false
										}}
										text={<FormattedMessage id="Common.label.cancel" />}
										icon={<CancelIcon />}
									/>
								</Grid>
							</Grid>
						</form>
					) : (
						<XsButton
							className="xs-default xs-outline xs-addAnother"
							icon={<i className="fal fa-plus-circle" />}
							text={<FormattedMessage id="Common.button.addAnother" />}
							onClick={() => {
								ConsentFormStore.isAdd = true
								ConsentFormStore.editable = false
								this.initForm()
							}}
						/>
					)}
				</div>
				<XsConfirmationDialog
					name="xsDeletePatientConsent"
					text={<FormattedMessage id="Patient.form.consentForm.confirmationMessage" />}
					type="danger"
					headerConfig={{
						text: "Common.label.warning",
						icon: <i className="fal fa-trash-alt fa-2x" />
					}}
					cancelBtn={{
						icon: <i className="fal fa-times fa-lg" />,
						text: "Common.btn.not.delete"
					}}
					confirmBtn={{
						icon: <i className="fal fa-trash-alt fa-lg" />,
						text: "Common.btn.consent.delete"
					}}
					onConfirmation={() => this.deleteConsent()}
				/>
				{ConsentFormStore.isOpenConsentTemplate && <ConsentTemplateDialog />}
			</div>
		)
	}
}
